<template>
  <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Busqueda de Persona Natural u Juridica ("{{ title }}") </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mTypeSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"   value="identification" v-model="optionSearchPerson" checked> Nombre
                            </label>
                            <label class="btn btn-success" @click="mTypeSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2"  value="name" v-model="optionSearchPerson"> # Identificacion
                            </label>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6 offset-md-3">
                                <label for="brand_engine" class="badge badge-primary">Datos de la Busqueda</label>
                                <input type="text" class="form-control" name="flag" :placeholder="placeSearch" autocomplete="off" v-model="dataSearch">
                                <small id="enrollmentHelp" class="form-text text-muted">Teclee su {{ placeSearch }} </small>
                            </div>
                        </div>
                        <br>
                        <button class="btn btn-info col-12 col-md-4 offset-md-4" @click="mSearchPerson">Buscar</button>
                                                                   
                        <div class="responsive" v-if="dataPerson.length>0">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>No. Identificacion</th>
                                        <th>Tipo</th>
                                        <th>&#10004;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, key) in dataPerson" :key="dt.id_person">
                                        <td>{{ key+1 }}</td>
                                        <td>{{ dt.complete }}</td>
                                        <td>{{ dt.identification }}</td>
                                        <td>{{ dt.type_person }}</td>
                                        <td><button class="btn btn-success" @click="mSelectComplaintVictim(dt)"><font-awesome-icon icon="check" /></button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>    
                    </div>               
                    
                    <div class="modal-footer">
                        
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                        
                    </div>
                </div>
            </div>
            
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

export default {
    name:'modal-search-person',
    props:{
        idModal:String,
        typeSelect:{
            type:String,
            default:'D'
        },
        title:{
            type:String,
            default:'Denunciado'
        },
        model:{
            type:String,
            default:'sComplaintsPersons/addPersonComplaint'
        }
    },
    data(){
        return{
            optionSearchPerson:'name',
            dataSearch:null,
            dataPerson:[],

        }
    },
    methods:{
        mTypeSearch(){            
            
                var radios=$("input[type=radio]").parents('label');
                let radioV;                
                    for(let i=0;i<radios.length;i++){                    
                        if($(radios[i]).hasClass('active')){
                            radioV=$(radios[i]).children('input').attr('value');
                        }
                    }
                this.optionSearchPerson=radioV;
            
            // console.log(`el parametro de busqueda es ${this.optionSearchPerson}`);
        },

        async mSearchPerson(){
            
            if(this.dataSearch !== null && this.dataSearch!==' '){
                this.dataPerson=[];
                let bperson=await axios.get(`searchPersonComplaint/${this.optionSearchPerson}/${this.dataSearch}?api_token=${Vue.auth.getToken()}`);
                console.log(bperson);
                if(bperson.data.length > 0){
                    // verificar si tiene y emitir un mensaje toast
                    bperson.data.forEach(el => {
                        let aux_p={
                            id_person:el.id,
                            complete:`${el.name} ${el.first_last_name} ${el.second_last_name}`,
                            identification:el.identification,
                            type_person:el.type_person === 'J' ? 'JURIDICA' : 'NATURAL',
                            type_person_short:el.type_person
                        };
                        this.dataPerson.push(aux_p);
                    });
                    
                }else{
                    toastr.info('No existen coincidencias de lo Buscado', 'Sin resultados')
                }
            }else{
                toastr.warning(`Indique su ${this.placeSearch}`, 'Error');
            }
            
        },
        mSelectComplaintVictim(e){
            // ace se indica si al seleccionarlo es como denunciado o victima D denunciante S sindicado V victima
            let aux_person={
                id_temp:`${e.id_person}${this.typeSelect}`,
                id_person:e.id_person,
                type_select:this.typeSelect,
                complete:e.complete,
                identification:e.identification,
                type_person:e.type_person,
                type_person_short:e.type_person_short
            }
            this.$store.dispatch(this.model, aux_person);
        }
    },
    computed:{
        placeSearch(){
            switch(this.optionSearchPerson){
                case 'name':
                    return 'Nombre completo de la Persona u Empresa';
                break;

                case 'identification':
                    return 'Numero de Identificacion';
                break;
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/complaints/modalSearchPerson.vue